import { Link } from 'react-router-dom';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { FiChevronDown, FiLock, FiUnlock, FiCheckCircle, FiEdit3, FiCheck, FiChevronUp, FiMessageCircle, FiTarget } from 'react-icons/fi';
import {
  ClassroomModule,
  ClassroomModuleActions,
  ClassroomModuleBody,
  ClassroomModuleCount,
  ClassroomModuleHeader,
  ClassroomModuleHeaderContent,
  ClassroomModuleIcon,
  ClassroomModuleItem,
  ClassroomModuleItemIcon,
  ClassroomModuleItemMessages,
  ClassroomModuleItemTitle,
  ClassroomModuleNotificationNewMessage,
  ClassroomModuleTitle
} from '@/components/custom/classroom';
import { PATHS } from '@/routes/paths';
import { isScheduledPublication } from '@/components/custom/schedule-publication-modal';

const allRequirementsFinished = (learningSystemItem, type) => {
  const requirements = (learningSystemItem?.requirements || []).filter(requirement => requirement.type === type);
  return requirements.length > 0 && requirements.every(requirement => requirement.finished);
};

export function CourseClassroomModuleItem(props) {
  const {
    learnigSystem,
    learningSystemItems,
    learnSystemContents,
    setSelectedItem,
    selectedItem,
    setSelectedContent,
    selectedContent,
    learnSystemContent,
    active,
    setActive,
    authorityLevel,
    index,
    changeTab,
    updateLearningSystemItems,
    updateLearningSystemUserItems,
    getLearnSystemContents
  } = props;

  const [blocked, setBlocked] = useState(false);

  const hasNewMessageInStudent = learningSystemItems.find(learningSystemItem => learningSystemItem['learning-system-user-items'][0]?.has_new_message);

  const blockModuleItem = () => {
    setBlocked(!blocked);
    setActive(learnSystemContent?.id);
  };

  useEffect(() => {
    if (isNaN(parseInt(active))) setActive(selectedContent?.id);
    const initBlockVar = active === learnSystemContent?.id;
    setBlocked(initBlockVar);
  }, []);

  const lastUnfinishedAndBlockedItem = learningSystemItems.find(item => !item['learning-system-user-items'][0]?.finished && item.unrequired === false);

  return (
    <ClassroomModule>
      <ClassroomModuleHeader onClick={blockModuleItem}>
        {authorityLevel !== 'student' && learnSystemContent['has-new-message'] && (
          <ClassroomModuleNotificationNewMessage>
            <FiMessageCircle />
          </ClassroomModuleNotificationNewMessage>
        )}
        {authorityLevel === 'student' && hasNewMessageInStudent && (
          <ClassroomModuleNotificationNewMessage>
            <FiMessageCircle />
          </ClassroomModuleNotificationNewMessage>
        )}

        <ClassroomModuleHeaderContent>
          {authorityLevel !== 'student' ? (
            <>
              <ClassroomModuleIcon>
                <FiUnlock />
              </ClassroomModuleIcon>
              <ClassroomModuleTitle title={learnSystemContent.body}>{learnSystemContent.body}</ClassroomModuleTitle>
            </>
          ) : (
            <>
              {learnSystemContent.finished ? (
                <>
                  <ClassroomModuleIcon isDone>
                    <FiUnlock />
                  </ClassroomModuleIcon>
                  <ClassroomModuleTitle title={learnSystemContent.body}>{learnSystemContent.body}</ClassroomModuleTitle>
                </>
              ) : learnSystemContent['is-allowed'] ? (
                <>
                  <ClassroomModuleIcon>
                    <FiUnlock />
                  </ClassroomModuleIcon>
                  <ClassroomModuleTitle title={learnSystemContent.body}>{learnSystemContent.body}</ClassroomModuleTitle>
                </>
              ) : (
                <>
                  <ClassroomModuleIcon isDisabled>
                    <FiLock />
                  </ClassroomModuleIcon>
                  <ClassroomModuleTitle
                    isDisabled
                    title={learnSystemContent.body}
                  >
                    {learnSystemContent.body}
                  </ClassroomModuleTitle>
                </>
              )}
            </>
          )}
        </ClassroomModuleHeaderContent>

        <ClassroomModuleActions>
          <ClassroomModuleCount>
            {learningSystemItems.length} {t('lms.lms')}
          </ClassroomModuleCount>
          {blocked ? <FiChevronUp size={16} /> : <FiChevronDown size={16} />}
        </ClassroomModuleActions>
      </ClassroomModuleHeader>

      <ClassroomModuleBody isActive={blocked}>
        {authorityLevel == 'student' &&
          learningSystemItems.map((learningSystemItem, i) => {
            const active = selectedItem?.id === learningSystemItem?.id ? 'active' : '';
            const lastUnfinishedandBlockedItemIndex = learningSystemItems.indexOf(lastUnfinishedAndBlockedItem);
            const isEnabled = lastUnfinishedAndBlockedItem ? i <= lastUnfinishedandBlockedItemIndex : true;

            return (
              <React.Fragment key={i}>
                <ClassroomModuleItem
                  isActive={active}
                  isDisabled={!((learnSystemContent['is-allowed'] && isEnabled) || learningSystemItem.order === 0)}
                  onClick={() => {
                    if ((learnSystemContent['is-allowed'] && isEnabled) || learningSystemItem.order === 0) {
                      setSelectedItem(learningSystemItem);
                      setSelectedContent(learnSystemContent);
                    }
                    if (learningSystemItem['learning-system-user-items'][0]?.has_new_message) {
                      updateLearningSystemUserItems(learningSystemItem['learning-system-user-items'][0]?.id);
                      getLearnSystemContents();
                    }
                  }}
                >
                  {learningSystemItem['learning-system-user-items'][0] && learningSystemItem['learning-system-user-items'][0].finished ? (
                    <ClassroomModuleItemIcon isDone>
                      <FiCheck />
                    </ClassroomModuleItemIcon>
                  ) : (
                    <ClassroomModuleItemIcon />
                  )}
                  <ClassroomModuleItemTitle title={learningSystemItem.body}>{learningSystemItem.body}</ClassroomModuleItemTitle>
                  {learningSystemItem['learning-system-user-items'][0]?.has_new_message && (
                    <ClassroomModuleItemMessages isNew>
                      <FiMessageCircle /> {learningSystemItem['message-count']}
                    </ClassroomModuleItemMessages>
                  )}
                  {!learningSystemItem['learning-system-user-items'][0]?.has_new_message && (
                    <ClassroomModuleItemMessages>
                      <FiMessageCircle /> {learningSystemItem['message-count']}
                    </ClassroomModuleItemMessages>
                  )}
                </ClassroomModuleItem>

                {active && (learningSystemItem?.requirements || []).length > 0 && (
                  <>
                    {learningSystemItem?.requirements.some(requirement => requirement.type === 'QuestionBook') && (
                      <ClassroomModuleItem
                        isRequirement
                        onClick={() => changeTab('courseClassroomQuestionBooks')}
                      >
                        <ClassroomModuleItemIcon
                          isRequirement
                          isDone={allRequirementsFinished(learningSystemItem, 'QuestionBook')}
                        >
                          {allRequirementsFinished(learningSystemItem, 'QuestionBook') ? <FiCheck /> : <FiCheckCircle />}
                        </ClassroomModuleItemIcon>
                        <ClassroomModuleItemTitle>Exercício</ClassroomModuleItemTitle>
                      </ClassroomModuleItem>
                    )}

                    {learningSystemItem?.requirements.some(requirement => requirement.type === 'Activity') && (
                      <ClassroomModuleItem
                        isRequirement
                        onClick={() => changeTab('courseClassroomActivities')}
                      >
                        <ClassroomModuleItemIcon
                          isRequirement
                          isDone={allRequirementsFinished(learningSystemItem, 'Activity')}
                        >
                          {allRequirementsFinished(learningSystemItem, 'Activity') ? <FiCheck /> : <FiEdit3 />}
                        </ClassroomModuleItemIcon>
                        <ClassroomModuleItemTitle>Atividade complementar</ClassroomModuleItemTitle>
                      </ClassroomModuleItem>
                    )}
                  </>
                )}
              </React.Fragment>
            );
          })}

        {authorityLevel !== 'student' &&
          learningSystemItems.map((learningSystemItem, i) => {
            const active = selectedItem?.id === learningSystemItem?.id ? 'active' : '';

            return (
              <React.Fragment key={i}>
                <ClassroomModuleItem
                  isActive={active}
                  onClick={() => {
                    setSelectedItem(learningSystemItem);
                    setSelectedContent(learnSystemContent);
                    if (learningSystemItem['has-new-message']) {
                      updateLearningSystemItems(learningSystemItem?.id);
                      getLearnSystemContents();
                    }
                  }}
                >
                  <ClassroomModuleItemIcon />

                  <ClassroomModuleItemTitle>{learningSystemItem.body}</ClassroomModuleItemTitle>
                  {learningSystemItem['has-new-message'] && (
                    <ClassroomModuleItemMessages isNew>
                      <FiMessageCircle /> {learningSystemItem['message-count']}
                    </ClassroomModuleItemMessages>
                  )}
                  {!learningSystemItem['has-new-message'] && (
                    <ClassroomModuleItemMessages>
                      <FiMessageCircle /> {learningSystemItem['message-count']}
                    </ClassroomModuleItemMessages>
                  )}
                </ClassroomModuleItem>

                {active && (learningSystemItem?.requirements || []).length > 0 && (
                  <>
                    {learningSystemItem?.requirements.some(requirement => requirement.type === 'QuestionBook') && (
                      <ClassroomModuleItem
                        isRequirement
                        onClick={() => changeTab('courseClassroomQuestionBooks')}
                      >
                        <ClassroomModuleItemIcon isRequirement>
                          <FiCheckCircle />
                        </ClassroomModuleItemIcon>
                        <ClassroomModuleItemTitle>Exercício</ClassroomModuleItemTitle>
                      </ClassroomModuleItem>
                    )}

                    {learningSystemItem?.requirements.some(requirement => requirement.type === 'Activity') && (
                      <ClassroomModuleItem
                        isRequirement
                        onClick={() => changeTab('courseClassroomActivities')}
                      >
                        <ClassroomModuleItemIcon isRequirement>
                          <FiEdit3 />
                        </ClassroomModuleItemIcon>
                        <ClassroomModuleItemTitle>Atividade complementar</ClassroomModuleItemTitle>
                      </ClassroomModuleItem>
                    )}
                  </>
                )}
              </React.Fragment>
            );
          })}
      </ClassroomModuleBody>

      {index === learnSystemContents?.length - 1 &&
        (learnigSystem?.['question-books'] || [])
          .filter(qb => {
            const linked = (learnigSystem?.['learning-system-question-books'] || []).find(lsqb => lsqb['question-book']?.id === qb.id);
            // Exercício agendado fica fora desta lista (só nome, sem como mostrar o "Em breve");
            // ele aparece no card da aba Exercícios.
            return !linked?.['learning-system-item-id'] && !(qb.type === 'train' && isScheduledPublication(qb));
          })
          .map(qb => {
          const isDisabled = qb?.['able-to-retry'] ? false : qb.finished;

          return (
            <ClassroomModuleItem
              isDisabled={isDisabled}
              isRequirement
              asChild
            >
              <Link
                key={qb.id}
                to={qb.type === 'exam' ? `/provas/${qb.id}` : qb.type === 'train' ? `/questions/apostilas/${qb.id}` : `/simulados/${qb.id}`}
                state={qb.type === 'train' ? { returnTo: PATHS.COURSE.MODULE(learnigSystem?.course?.id, learnigSystem?.id, 'apostilas') } : undefined}
              >
                <ClassroomModuleItemIcon isRequirement>
                  <FiTarget />
                </ClassroomModuleItemIcon>
                <ClassroomModuleItemTitle>{qb.title}</ClassroomModuleItemTitle>
              </Link>
            </ClassroomModuleItem>
          );
        })}
    </ClassroomModule>
  );
}
